import {
  formatOptionResponseLabel,
  responseCountForMath,
} from '@/lib/campaign-question-stats'
import styles from './PerguntasManager.module.css'

interface QuestionOptionStatsRowProps {
  label: string
  responseCount: number | undefined
  totalResponses: number | undefined
}

export function QuestionOptionStatsRow({
  label,
  responseCount,
  totalResponses,
}: QuestionOptionStatsRowProps) {
  const countForMath = responseCountForMath(responseCount)
  const totalForMath = responseCountForMath(totalResponses)
  const percent =
    totalForMath > 0 ? Math.min(100, Math.round((countForMath / totalForMath) * 100)) : 0

  return (
    <li className={styles.optionItem}>
      <div className={styles.optionStatsHeader}>
        <span className={styles.optionLabel}>{label}</span>
        <span className={styles.optionCount}>{formatOptionResponseLabel(responseCount)}</span>
      </div>
      <div
        className={styles.optionBar}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${label}: ${percent}% das respostas`}
      >
        <div className={styles.optionBarFill} style={{ width: `${percent}%` }} />
      </div>
      <span className={styles.optionPercent}>{percent}%</span>
    </li>
  )
}
